import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, Params } from '@angular/router';
import { DATA_RECREAR_AL_CAMBIAR_PARAMETROS } from './navegacion-registros.model';

/**
 * Angular reutiliza el componente de una ruta cuando solo cambian sus parámetros: `/x/5 → /x/6` cambia la URL y
 * deja en pantalla el registro 5, porque casi todos los detalles leen el id una sola vez
 * (`route.snapshot.paramMap`). En vez de reescribir cada detalle para que escuche `paramMap`, la ruta que lo pide
 * se crea de nuevo cuando cambian sus parámetros:
 *
 *   { path: ':id', loadComponent: …, data: { recrearAlCambiarParametros: true } }
 *
 * Solo mira el `data` declarado en la propia ruta (no el heredado del padre), y solo los parámetros de la ruta: un
 * cambio de query params (`?tab=`) sigue reutilizando el componente. El resto de las rutas se comporta como
 * siempre.
 */
@Injectable()
export class RecrearAlCambiarParametrosStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) return false;
    if (future.routeConfig?.data?.[DATA_RECREAR_AL_CAMBIAR_PARAMETROS] && !mismosParametros(future.params, curr.params)) {
      return false;
    }
    return true;
  }
}

function mismosParametros(a: Params, b: Params): boolean {
  const ka = Object.keys(a);
  const kb = Object.keys(b);
  return ka.length === kb.length && ka.every(k => a[k] === b[k]);
}
